import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const exhibitionPhotoService = {
  // Get all photos for an exhibition
  getPhotosByExhibition: async (exhibitionId) => {
    const response = await api.get(`/exhibitions/${exhibitionId}/photos`);
    return response.data;
  },

  // Add photo to exhibition
  addPhoto: async (exhibitionId, formData) => {
    const data = new FormData();
    data.append('image', formData.image);
    if (formData.title) {
      data.append('title', formData.title);
    }
    if (formData.description) {
      data.append('description', formData.description);
    }

    const response = await axios.post(`${config.API_URL}/exhibitions/${exhibitionId}/photos`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete photo
  deletePhoto: async (photoId) => {
    const response = await api.delete(`/exhibitions/photos/${photoId}`);
    return response.data;
  },

  // Update photo order
  updatePhotoOrder: async (photoId, displayOrder) => {
    const response = await api.put(`/exhibitions/photos/${photoId}/order`, {
      display_order: displayOrder
    });
    return response.data;
  }
};

export default exhibitionPhotoService; 